export default "__VITE_ASSET__16eec2ab__"